@if ((authService.isAuthenticated$ | async); as isAuthenticated) {
  @if (isAuthenticated) {
    <app-navigation></app-navigation>
  }
  @if (!isAuthenticated) {
    <h2></h2>
  }
}
